import $http from '@vue-util/http';

export const useCitiRedirectStore = defineStore('citiRedirect', {
  state: () => ({
    citiFormData: {},
  }),
  actions: {
    setCitiForm(formData) {
      this.citiFormData = formData;
    },
    fetchCitiUrl(options) {
      const headers = {
        headers: {
          'X-Macys-UID': options.userId,
          'X-Macys-GUID': options.userGuid,
          'X-Macys-SecurityToken': encodeURIComponent(options.secureUserToken),
          'X-Macys-ClientId': 'account-ui',
          action: options.action,
        },
      };
      if (options.cardId !== '') {
        headers.headers.cid = options.cardId;
      }

      $http
        .get(`/account-xapi/api/creditservice/creditdeeplink?_deviceType=${options.deviceType}&timeStamp=${Date.now()}`, headers)
        .then((response) => {
          const formData = response.data.creditDeeplinkData;
          formData.signedIn = formData.signedIn ? 1 : 0;
          this.setCitiForm(response.data.creditDeeplinkData);
          this.clearCitiCache(options);
        })
        .catch(() => {});
    },
    fetchApplyNowUrl(options) {
      const headers = {
        headers: {
          'X-Macys-ClientId': 'account-ui',
        },
      };
      $http
        .get(`/account-xapi/api/creditservice/applynow?_deviceType=${options.deviceType}`, headers)
        .then((response) => {
          this.setCitiForm(response.data.creditAcquisition);
        })
        .catch(() => {});
    },
    clearCitiCache(options) {
      const requestId = `${options.userGuid + Math.floor(Date.now() / 1000)}`;
      const headers = {
        headers: {
          'X-Macys-Request-Id': requestId,
          'X-Macys-ClientId': options.deviceType,
          'X-Macys-UID': options.userId,
          'X-Macys-GUID': options.userGuid,
          'X-Macys-SecurityToken': encodeURIComponent(options.secureUserToken),
        },
      };
      $http
        // make xAPI call to clear cache for SSO actions, response not needed
        .get('/account-xapi/api/creditservice/invalidateinlinecache', headers)
        .then(() => {})
        .catch(() => {});
    },
  },
});
